/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface FindAllScreenerBedUnits200Response
 */
export interface FindAllScreenerBedUnits200Response {
    /**
     * 
     * @type {Array<ScreenerBedUnit>}
     * @memberof FindAllScreenerBedUnits200Response
     */
    data?: Array<ScreenerBedUnit>;
}

/**
 * Check if a given object implements the FindAllScreenerBedUnits200Response interface.
 */
export function instanceOfFindAllScreenerBedUnits200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerBedUnits200ResponseFromJSON(json: any): FindAllScreenerBedUnits200Response {
    return FindAllScreenerBedUnits200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerBedUnits200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerBedUnits200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ScreenerBedUnitFromJSON)),
    };
}

export function FindAllScreenerBedUnits200ResponseToJSON(value?: FindAllScreenerBedUnits200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ScreenerBedUnitToJSON)),
    };
}

